import { useState } from "react";
import { SITE, GALLERY_CATEGORIES } from "../config/site";
import { SectionHeading, Reveal } from "./Reveal";

export function GallerySection() {
  const [cat, setCat] = useState("all");
  const photos = SITE.gallery.filter((p) => cat === "all" || p.category === cat);

  return (
    <section data-testid="gallery-section" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
      <SectionHeading
        eyebrow="Real Repair Work"
        title="The Shop Comes to You"
        sub="Actual mobile brake jobs, before-and-afters and behind-the-scenes work from driveways and parking lots across the Merrimack Valley."
      />

      <Reveal className="mt-8 flex flex-wrap gap-2">
        {GALLERY_CATEGORIES.map((c) => (
          <button
            key={c.id}
            data-testid={`gallery-filter-${c.id}`}
            onClick={() => setCat(c.id)}
            className={`min-h-[44px] border px-4 font-mono text-xs font-bold uppercase tracking-widest transition-colors ${
              cat === c.id
                ? "border-crimson bg-crimson text-white"
                : "border-edge text-slate-400 hover:border-edgehi hover:text-slate-200"
            }`}
          >
            {c.label}
          </button>
        ))}
      </Reveal>

      <div className="mt-8 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
        {photos.map((p, i) => (
          <Reveal key={`${p.src}-${i}`} delay={(i % 4) * 0.06}>
            <figure
              data-testid={`gallery-photo-${i}`}
              className="group clip-frame relative aspect-square overflow-hidden border border-edge bg-slate2"
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-obsidian/95 to-transparent px-3 pb-3 pt-8 font-mono text-[10px] uppercase tracking-widest text-amber2">
                {p.caption}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
